import { arrayOf, boolOf, fail, idOf, numberOf, objectOf, optionalNumber, optionalText, textOf } from '../../../shared/api/wire'
import type { AqsiSaleExchange, AqsiSaleExchangeList } from '../model/types'

export const EXCHANGE_KINDS = {
  sale: 'aqsi.sale.exchanges',
} as const

function instantOf(value: unknown, field: string): string {
  const text = textOf(value, field)
  return Number.isNaN(Date.parse(text)) ? fail(`${field} — не дата`) : text
}

function integerOf(value: unknown, field: string): number {
  const number = numberOf(value, field)
  return Number.isSafeInteger(number) ? number : fail(`${field} — не целое число`)
}

function optionalInteger(value: unknown, field: string): number | null {
  const number = optionalNumber(value, field)
  return number === null || Number.isSafeInteger(number) ? number : fail(`${field} — не целое число`)
}

function decodeExchange(raw: unknown, field: string): AqsiSaleExchange {
  const item = objectOf(raw, field)
  return {
    id: idOf(item.id, `${field}.id`),
    relation: textOf(item.relation, `${field}.relation`),
    operationId: optionalText(item.operationId, `${field}.operationId`),
    operationKind: optionalText(item.operationKind, `${field}.operationKind`),
    externalOperationId: optionalText(item.externalOperationId, `${field}.externalOperationId`),
    deviceId: optionalInteger(item.deviceId, `${field}.deviceId`),
    command: textOf(item.command, `${field}.command`),
    method: textOf(item.method, `${field}.method`),
    path: textOf(item.path, `${field}.path`),
    sentAt: instantOf(item.sentAt, `${field}.sentAt`),
    answeredAt: instantOf(item.answeredAt, `${field}.answeredAt`),
    durationMs: integerOf(item.durationMs, `${field}.durationMs`),
    requestBody: textOf(item.requestBody, `${field}.requestBody`),
    requestLength: integerOf(item.requestLength, `${field}.requestLength`),
    httpStatus: optionalInteger(item.httpStatus, `${field}.httpStatus`),
    responseBody: optionalText(item.responseBody, `${field}.responseBody`),
    responseLength: optionalInteger(item.responseLength, `${field}.responseLength`),
    failure: optionalText(item.failure, `${field}.failure`),
    note: optionalText(item.note, `${field}.note`),
    mentionedOperationId: optionalText(item.mentionedOperationId, `${field}.mentionedOperationId`),
  }
}

/** Журнал обмена: продажа в ответе обязана быть той, что запрошена. */
export function decodeSaleExchanges(raw: unknown, saleId: string): AqsiSaleExchangeList {
  const data = objectOf(raw, 'журнал обмена')
  const answered = idOf(data.saleId, 'saleId')
  if (answered.toLowerCase() !== saleId.toLowerCase()) fail('в ответе другая продажа, чем в запросе')
  return {
    saleId: answered,
    items: arrayOf(data.items, 'items').map((item, index) => decodeExchange(item, `items[${index}]`)),
    complete: boolOf(data.complete, 'complete'),
  }
}
